export default "/assets/images/mila-feed-12-thumbnail.8a29e165fa12aa67.jpg";